import React,{useState, useEffect} from 'react';
import { Table, DatePicker, Button, Space, Input } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment'

import Api from "../../../../api";
import {pagingParam} from "../../../../utils/defaultValue";
import {downloadFileBlob, get7DaysDate} from "../../../../utils/tool";
import SelfTable from "../../../../components/SelfTable/index"

import './index.scss'

const { RangePicker } = DatePicker;

const PersonalStatistics = ({departmentList}) => {

    const defalRange = get7DaysDate();

    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });
    const [sortedInfo, setSortedInfo] = useState({});
    // 查询数据
    const [searchData, setSearchData] = useState({
        ...pagingParam,
        ...defalRange
    });

    const [operationData, setOperationData] = useState(defalRange);

    const [tableLoading, setTableLoading] = useState(false);

    const [listData, setListData] = useState([]);
    const columns = [
        {
            title: '作者姓名',
            dataIndex: 'authorName',
            width: '',
        },
        {
            title: '工号',
            dataIndex: 'authorJobNum',
            width: '120px',
        },
        {
            title: '所属部门',
            dataIndex: 'departmentId',
            width: '200px',
            filters: [...departmentList.filter((val, i) => {
                return val.value !== ''
            })],
            filterMultiple:false,
            filteredValue:searchData.departmentId ? [searchData.departmentId] : [],
            render:(_, record)=>{
                return record.departmentName
            },
        },
        {
            title: '上传数量（篇）',
            dataIndex: 'uploadNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'uploadNum' ? sortedInfo.order : null,
        },
        {
            title: '创作数量（篇）',
            dataIndex: 'creationNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'creationNum' ? sortedInfo.order : null,
        },
        {
            title: '被阅读量(次）',
            dataIndex: 'beReadNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'beReadNum' ? sortedInfo.order : null,
        },
        {
            title: '被下载量（次）',
            dataIndex: 'beDownloadNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'beDownloadNum' ? sortedInfo.order : null,
        },
        {
            title: '被收藏量（次）',
            dataIndex: 'beCollectionNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'beCollectionNum' ? sortedInfo.order : null,
        },
        {
            title: '收获点赞量(次）',
            dataIndex: 'likeNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'likeNum' ? sortedInfo.order : null,
        },
        {
            title: '收获评论量（条）',
            dataIndex: 'commentNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'commentNum' ? sortedInfo.order : null,
        },
        {
            title: '评论量（次）',
            dataIndex: 'answerNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'answerNum' ? sortedInfo.order : null,
        }
    ];

    useEffect(()=>{
        getList()
    },[JSON.stringify(searchData)])

    const getList = async() => {
        setTableLoading(true);
        const res = await Api.Statistics.getPersonalStatisticsList({data:searchData});
        setTableLoading(false);
        if(res&&res.code === 0){
            let _data = res.data;
            setListData(_data.records);
            setPagination({
                "pageIndex": _data.current,
                "pageSize": _data.size,
                "total":_data.total
            });
        }else{
            setListData([]);
        }
    }

    const onChanges = (pagination, filters, sorter, extra) => {
        let newSearchData = {...searchData}
        newSearchData.typeSortMessage = sorter.field === 'uploadNum' ? 0:
        sorter.field === 'beReadNum' ? 1:
        sorter.field === 'beDownloadNum' ? 2:
        sorter.field === 'beCollectionNum' ? 3:
        sorter.field === 'likeNum' ? 4:
        sorter.field === 'commentNum' ? 5:
        sorter.field === 'answerNum' ? 6:
        sorter.field === 'creationNum' ? 7:'';
        newSearchData.sort = sorter.order === 'descend' ? 0 : sorter.order === 'ascend' ? 1 :'';
        setSortedInfo({
            order: sorter.order,
            columnKey: sorter.field,
        });
        newSearchData.pageIndex = pagination.current;
        newSearchData.pageSize = pagination.pageSize;
        for (let key in filters) {
            newSearchData[key] = filters[key] ? filters[key][0] : ''
        }
        setSearchData(newSearchData);
    };

    const dateChange = (date, dateString) => {
        let newSearchData = {...searchData}
        newSearchData.startTime = dateString[0];
        newSearchData.endTime = dateString[1];
        newSearchData.pageIndex = 1;
        setSearchData(newSearchData);
    }

    const onSearch = () => {
        operationData.authorName = operationData.authorName ? operationData.authorName.trim(): operationData.authorName
        operationData.authorJobNum = operationData.authorJobNum ? operationData.authorJobNum.trim(): operationData.authorJobNum
        setSearchData({
            ...searchData,
            ...operationData
        });
    }

    const exportFile = async() => {
        try{
            const res = await Api.Statistics.getPersonalStatisticsExport({data:searchData});
            if(res){
                downloadFileBlob(res,'个人知识贡献统计明细.xlsx')
            }
        }catch{

        }
    }

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        if(type === "timeRange"){
            newOperationData.startTime = value[0];
            newOperationData.endTime = value[1];
        }else{
            newOperationData[type] = value;
        }
        newOperationData.pageIndex = 1;
        setOperationData(newOperationData)
    }

    const onResetting = () => {
        setOperationData({
            ...defalRange,
            authorName:"",
            authorJobNum:""
        });
        setSearchData({
            ...pagingParam,
            ...defalRange
        })
        setSortedInfo({});
    }
    
    const disabledDate = (current) => {
        // Can not select days after today and today
        return current && current > moment().endOf('day');
    };

    return(
        <div className="personalStatisticsFrame">
            <div className="title">个人知识贡献统计</div>
            <div className="operation">
                <div className="operationLeft">
                    <div className="operationItem">
                        <span>选择时段：</span>
                        <RangePicker 
                        ranges={{
                            '当天': [moment(), moment()],
                            '近7天':[moment().subtract(7, 'day'), moment()],
                            '本月': [moment().startOf('month'), moment()],
                            '近三个月': [moment().subtract(3, 'months'), moment()],
                        }}
                        disabledDate={disabledDate}
                        value={operationData.startTime?[moment(operationData.startTime), moment(operationData.endTime)]:[]}
                        onChange={(date, dateString)=>{
                            searchChange(dateString,"timeRange")
                        }}/>
                    </div>
                    <div className="operationItem">
                        <span className='operationtitle'>作者姓名：</span>
                        <Input value={operationData.authorName} onPressEnter={onSearch} placeholder='请输入作者姓名' allowClear onChange={(e)=>{
                            searchChange(e.target.value,"authorName")
                        }}/>
                    </div>
                    <div className="operationItem">
                        <span className='operationtitle'>工号：</span>
                        <Input value={operationData.authorJobNum} onPressEnter={onSearch} placeholder='请输入工号' allowClear onChange={(e)=>{
                            searchChange(e.target.value,"authorJobNum")
                        }}/>
                    </div>
                    <div className="operationItem">
                        <Space size={"large"}>
                            <Button type="primary" onClick={onSearch}>搜索</Button>
                            <Button onClick={onResetting}>重置</Button>
                        </Space>
                    </div>
                </div>
                <div className="operationRight">
                    <Space size={"large"}>
                        <Button onClick={exportFile} icon={<DownloadOutlined />}>导出</Button>
                    </Space>
                </div>
            </div>
            <div className="table">
                <SelfTable
                    dataSource={listData}
                    columns={columns}
                    pagination={pagination}
                    loading={tableLoading}
                    onChange={onChanges} 
                    scroll={
                        {
                            x:"1800px"
                        }
                    }
                />
                {/* <Table 
                    rowKey="id" 
                    columns={columns} 
                    bordered 
                    dataSource={listData} 
                    onChange={onChanges} 
                    pagination={{
                        total:pagination.total,
                        current:pagination.pageIndex,
                        pageSize:pagination.pageSize,
                        showSizeChanger:true,
                        showQuickJumper:true,
                        showTotal:()=> `总计${pagination.total}条数据`
                    }}
                    scroll={{
                        scrollToFirstRowOnChange:true,
                        y:tableHight
                    }}
                    loading={tableLoading}
                /> */}
            </div>
        </div>
    )
}
export default PersonalStatistics